var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteFullLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1469.67,
    height: 282.33,
    viewBox: "0 0 1469.67 282.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    transform: "translate(-3113.33 -9647.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(-8851.67 574.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M345.02,195.05a62.473,62.473,0,0,1,0-60.02,56.353,56.353,0,0,1,21.11-21.27,61.691,61.691,0,0,1,54.35-2.75v31.55a36.89,36.89,0,0,0-10.84-6.87,33.706,33.706,0,0,0-13.26-2.67,31.97,31.97,0,0,0-16.34,4.12,29.339,29.339,0,0,0-11.16,11.48,35.388,35.388,0,0,0,0,32.84,29.275,29.275,0,0,0,11.16,11.48,31.975,31.975,0,0,0,16.34,4.13,33.635,33.635,0,0,0,13.26-2.67,36.914,36.914,0,0,0,10.84-6.88v31.55a58.738,58.738,0,0,1-24.1,5.02,59.363,59.363,0,0,1-30.25-7.76A56.38,56.38,0,0,1,345.02,195.05Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M431.77,200.22a48.536,48.536,0,0,1,0-48.7,47.748,47.748,0,0,1,17.8-17.47,51.592,51.592,0,0,1,49.74,0,47.5,47.5,0,0,1,17.87,17.47,48.536,48.536,0,0,1,0,48.7,47.5,47.5,0,0,1-17.87,17.47,51.592,51.592,0,0,1-49.74,0A47.528,47.528,0,0,1,431.77,200.22Zm61.95-12.77a23.881,23.881,0,0,0,0-23.14,22.18,22.18,0,0,0-38.67,0,23.881,23.881,0,0,0,0,23.14,22.021,22.021,0,0,0,8.09,8.25,22.64,22.64,0,0,0,22.49,0A22.021,22.021,0,0,0,493.72,187.45Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M532.02,221.66V92.24h27.01V221.66Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M571.18,221.66V92.24H598.2V221.66Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M612.61,200.79a53.523,53.523,0,0,1,0-49.82,43.652,43.652,0,0,1,17.15-17.15,53.523,53.523,0,0,1,49.82,0,43.718,43.718,0,0,1,17.15,17.15,50.164,50.164,0,0,1,6.15,24.91,36.936,36.936,0,0,1-.81,8.41H634.45a20.5,20.5,0,0,0,6.95,12.13,20.222,20.222,0,0,0,13.27,4.37,21.531,21.531,0,0,0,8.73-1.78,16.5,16.5,0,0,0,6.63-5.18h29.6a48.169,48.169,0,0,1-17.87,22.16,47.546,47.546,0,0,1-27.1,8.09,50.137,50.137,0,0,1-24.91-6.15A43.667,43.667,0,0,1,612.61,200.79Zm55.24-45.94a22.076,22.076,0,0,0-26.37,0,21.417,21.417,0,0,0-7.03,12.13h40.44A21.34,21.34,0,0,0,667.85,154.85Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M717.23,241.96a37.372,37.372,0,0,1-8.33-16.58h29.28c1.18,3.02,3.67,5.28,7.44,6.79a31.982,31.982,0,0,0,10.84,1.46q11,0,16.99-5.18,5.82-4.845,5.82-13.42v-6.47a31.916,31.916,0,0,1-12.13,9.71,37.964,37.964,0,0,1-15.85,3.24,42.93,42.93,0,0,1-22.57-5.99,41.358,41.358,0,0,1-15.53-16.66,51.627,51.627,0,0,1-5.58-24.27,51.627,51.627,0,0,1,5.58-24.27,41.358,41.358,0,0,1,15.53-16.66,42.93,42.93,0,0,1,22.57-5.99,37.808,37.808,0,0,1,15.85,3.24,31.821,31.821,0,0,1,12.13,9.71V130.1h26.85v84.93q0,21.675-16.18,32.68-12.615,8.745-33.49,8.74-13.755,0-23.94-4.05A38.728,38.728,0,0,1,717.23,241.96Zm59.05-56.46a21.436,21.436,0,0,0,0-21.84,21.385,21.385,0,0,0-8.09-7.76,22.748,22.748,0,0,0-11.24-2.83,22.379,22.379,0,0,0-19.34,10.76,20.856,20.856,0,0,0,0,21.52,22.379,22.379,0,0,0,19.34,10.76,22.828,22.828,0,0,0,11.24-2.83A21.66,21.66,0,0,0,776.28,185.5Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M817.49,200.79a53.523,53.523,0,0,1,0-49.82,43.652,43.652,0,0,1,17.15-17.15,53.523,53.523,0,0,1,49.82,0,43.718,43.718,0,0,1,17.15,17.15,50.164,50.164,0,0,1,6.15,24.91,36.936,36.936,0,0,1-.81,8.41H839.33a20.457,20.457,0,0,0,6.96,12.13,20.214,20.214,0,0,0,13.26,4.37,21.531,21.531,0,0,0,8.73-1.78,16.5,16.5,0,0,0,6.63-5.18h29.6a48.169,48.169,0,0,1-17.87,22.16,47.546,47.546,0,0,1-27.1,8.09,50.137,50.137,0,0,1-24.91-6.15A43.667,43.667,0,0,1,817.49,200.79Zm55.24-45.94a22.076,22.076,0,0,0-26.37,0,21.417,21.417,0,0,0-7.03,12.13h40.44A21.4,21.4,0,0,0,872.73,154.85Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M921.87,208.88a30.324,30.324,0,0,1-5.98-15.53l15.37-3.4a22.177,22.177,0,0,0,7.04,13.34q5.58,4.935,14.96,4.93,9.06,0,15.13-4.77t6.06-11.73q0-6.315-5.58-10.76t-15.45-7.85l-7.44-2.59q-27.345-10.035-27.34-33.49a29.315,29.315,0,0,1,4.37-15.77,30.1,30.1,0,0,1,12.05-11,36.69,36.69,0,0,1,17.07-3.96,36.264,36.264,0,0,1,16.58,3.8,31.642,31.642,0,0,1,12.06,10.44,29.972,29.972,0,0,1,5.18,14.72l-14.88,3.24q-.975-7.605-5.58-12.05-4.62-4.44-12.86-4.45a17.975,17.975,0,0,0-12.38,4.53,14.911,14.911,0,0,0-.4,22.08c3.12,2.86,7.66,5.42,13.58,7.68l8.41,3.08q13.425,5.01,21.36,12.78t7.93,20.22a27.212,27.212,0,0,1-5.02,15.93,34.29,34.29,0,0,1-13.59,11.32,43.112,43.112,0,0,1-18.93,4.12,41.832,41.832,0,0,1-18.2-3.96A35.313,35.313,0,0,1,921.87,208.88Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M1004.09,92.24h16.02v49.99a30.66,30.66,0,0,1,12.38-10.67,39.294,39.294,0,0,1,17.06-3.56q15.525,0,24.91,8.09a29.578,29.578,0,0,1,8.17,11.25,38.484,38.484,0,0,1,2.83,15.12v59.21h-16.02V164.08q0-9.705-6.31-15.29t-16.83-5.58q-12.45,0-19.33,7.04t-6.87,19.98v51.44h-16.02V92.24Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M1100.22,200.22a52.488,52.488,0,0,1,0-48.7,44.878,44.878,0,0,1,16.5-17.23,44.362,44.362,0,0,1,23.29-6.31q22.65,0,34.46,17.63V130.08h16.18v91.56h-16.18V206.11q-11.8,17.64-34.46,17.63a44.81,44.81,0,0,1-39.79-23.52Zm69.96-8.01a32.845,32.845,0,0,0-11.57-44.49,30.866,30.866,0,0,0-16.18-4.37,32.184,32.184,0,0,0-28.07,16.18,32.645,32.645,0,0,0,11.73,44.49,31.718,31.718,0,0,0,16.34,4.37,30.867,30.867,0,0,0,16.18-4.37A32.284,32.284,0,0,0,1170.18,192.21Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M1202.17,130.09h16.02v14.56a24.956,24.956,0,0,1,9.22-11,28.182,28.182,0,0,1,16.34-5.02,30.029,30.029,0,0,1,14.4,3.56L1252,148.21a18.893,18.893,0,0,0-11-3.24,21.426,21.426,0,0,0-14.23,5.18,23.938,23.938,0,0,0-6.31,9.06,31.573,31.573,0,0,0-2.27,12.13v50.31h-16.02V130.09Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M1264.48,105.02a9.623,9.623,0,0,1,2.91-7.2,10.032,10.032,0,0,1,7.28-2.83,9.521,9.521,0,0,1,7.03,2.83,9.751,9.751,0,0,1,2.83,7.2,9.863,9.863,0,0,1-2.83,7.12,9.415,9.415,0,0,1-7.03,2.91,9.882,9.882,0,0,1-7.28-2.91A9.678,9.678,0,0,1,1264.48,105.02Zm2.1,116.64V130.1h16.02v91.56Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M1297.49,130.09h16.02v12.13a30.659,30.659,0,0,1,12.38-10.67,39.294,39.294,0,0,1,17.06-3.56q12.135,0,20.71,5.18a28.7,28.7,0,0,1,11.25,11.73,37.175,37.175,0,0,1,3.96,17.55v59.21h-16.02V164.07q0-9.705-6.31-15.29t-16.83-5.58q-12.45,0-19.33,7.04t-6.87,19.98v51.44h-16.02Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M1397.17,241.64a33.488,33.488,0,0,1-8.25-15.61h17.31q2.91,8.745,13.42,12.78,6.63,2.745,16.66,2.75,14.235,0,22.17-5.82,9.54-6.795,9.54-19.74V204.19q-11.8,17.64-34.46,17.63a45.312,45.312,0,0,1-23.3-6.15,43.927,43.927,0,0,1-16.5-16.9,50.536,50.536,0,0,1,0-47.73,44,44,0,0,1,16.5-16.9,45.312,45.312,0,0,1,23.3-6.15q22.65,0,34.46,17.63V130.09h16.18V216a40.075,40.075,0,0,1-4.21,18.77,34.453,34.453,0,0,1-12.29,13.26q-12.615,8.085-31.39,8.09a65.564,65.564,0,0,1-23.94-4.21A42.988,42.988,0,0,1,1397.17,241.64ZM1463.74,191a31.493,31.493,0,0,0-11.57-43.51,32.24,32.24,0,0,0-16.18-4.12,32.581,32.581,0,0,0-16.34,4.21,31.319,31.319,0,0,0-11.73,11.4,31.74,31.74,0,0,0,0,31.87,31.42,31.42,0,0,0,11.73,11.41,32.684,32.684,0,0,0,16.34,4.21,32.274,32.274,0,0,0,16.18-4.13A31.085,31.085,0,0,0,1463.74,191Z",
    transform: "translate(11950.47 9039.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(-8851.67 574.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    transform: "translate(11950.47 9039.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M254.19,231.87H86.42a3.73,3.73,0,1,0,0,7.46H254.19a3.73,3.73,0,1,0,0-7.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M254.19,245.48H86.42a3.73,3.73,0,1,0,0,7.46H254.19a3.73,3.73,0,1,0,0-7.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M254.19,259.09H86.42a3.73,3.73,0,0,0,0,7.46H254.19a3.73,3.73,0,1,0,0-7.46Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814",
    transform: "translate(11950.47 9039.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M72.1,293.47V231.15H54.41a18.037,18.037,0,0,0-12.49,5.05v33.47c-.01,0-.01-.01-.02-.01v21.9c.01,0,.01,0,.02.01v23.94l15.09-10.99L72.1,315.51V293.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M78.67,273.23v20.23c42.66-.05,134.31-.15,175.13-.27,12.97-.04,23.48-6.64,23.75-19.44l-.49-.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M235.41,33.18H56.68A42.148,42.148,0,0,0,14.53,75.33v181.4c0,13.32,6.75,26.15,20.79,32.5v-25.7a23.3,23.3,0,0,1-5.02-14.22A24.182,24.182,0,0,1,54.41,225.2h181a42.148,42.148,0,0,0,42.15-42.15V75.33A42.148,42.148,0,0,0,235.41,33.18ZM134.99,193.27c-34.09,0-61.73-24.97-61.73-55.76h83.85c34.09,0,61.72,24.97,61.72,55.76Zm22.11-72.41H73.26c0-30.8,27.64-55.76,61.73-55.76h83.84C218.83,95.89,191.19,120.86,157.1,120.86Z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFullLogo);
export default __webpack_public_path__ + "static/media/WhiteFullLogo.675ae47ab4e99c24fa2f9f5f7e9cb375.svg";
export { ForwardRef as ReactComponent };